import type { MockInspection } from '@/mocks/qms';

interface Props {
  inspection: MockInspection | null;
  onClose: () => void;
  onCreateNCR: (inspection: MockInspection) => void;
  onSkip: () => void;
}

export default function NCRPromptModal({ inspection, onClose, onCreateNCR, onSkip }: Props) {
  if (!inspection) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-white rounded-lg shadow-xl w-full max-w-md p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
            <i className="ri-error-warning-line text-red-600 text-lg" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Inspection Failed</h3>
            <p className="text-sm text-gray-500">{inspection.inspectionNumber}</p>
          </div>
        </div>

        <p className="text-sm text-gray-600 mb-6">
          The inspection for <span className="font-medium">{inspection.itemName}</span> has
          failed. One or more parameters did not meet the required standards. Would you like to
          create a Non-Conformance Report (NCR) for this failure?
        </p>

        <div className="flex justify-end gap-3">
          <button
            onClick={() => {
              onSkip();
              onClose();
            }}
            className="px-4 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50 whitespace-nowrap"
          >
            No, Skip
          </button>
          <button
            onClick={() => {
              onCreateNCR(inspection);
              onClose();
            }}
            className="px-4 py-2 bg-red-600 text-white rounded-md text-sm font-medium hover:bg-red-700 whitespace-nowrap"
          >
            Yes, Create NCR
          </button>
        </div>
      </div>
    </div>
  );
}